import { render, staticRenderFns } from "./ColorStockItem.vue?vue&type=template&id=02ead19e&"
import script from "./ColorStockItem.vue?vue&type=script&lang=ts&"
export * from "./ColorStockItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports